export default (host) =>
  (id, width, height, filename = 'file', extension = 'jpg', filter = '', centerX="center", centerY="top") =>
    `${process.env.REACT_APP_CDN_HOST}/files/images/${id}/crop/${width}x${height}/${filename}.${extension}?center_x=${centerX}&center_y=${centerY}${filter ? `&filter=${filter}` : ''}`
